import { render, staticRenderFns } from "./AttachmentUploading.vue?vue&type=template&id=c5e064a4"
import script from "./AttachmentUploading.vue?vue&type=script&lang=js"
export * from "./AttachmentUploading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports